import { render, staticRenderFns } from "./ConfigureSubdivisionsModal.vue?vue&type=template&id=4769b88e&scoped=true"
import script from "./ConfigureSubdivisionsModal.vue?vue&type=script&lang=js"
export * from "./ConfigureSubdivisionsModal.vue?vue&type=script&lang=js"
import style0 from "./ConfigureSubdivisionsModal.vue?vue&type=style&index=0&id=4769b88e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4769b88e",
  null
  
)

export default component.exports